//券包第七期改版用到的一个定时器组件

import React from 'react'
import '../../../css/page/ActivityPage.css';

class CountDown extends  React.Component{
    constructor(props){
        super(props)
    }

    componentDidMount(){
        this.beginCountdown(this.props.endTime)
    }

    //开启倒计时
    beginCountdown(endTime) {
        let DateNow = parseFloat(endTime - (new Date().getTime() / 1000))

        if(DateNow===0){
            clearTimeout(this.timer);
        }else{
            this.timer = setTimeout(()=>{
                let DateNow = parseFloat(endTime - (new Date().getTime() / 1000))
                let days = parseInt(DateNow  / 60 / 60 / 24, 10); //计算剩余的天数
                let hours = parseInt(DateNow  / 60 / 60 % 24, 10); //计算剩余的小时
                let minutes = parseInt(DateNow  / 60 % 60, 10);//计算剩余的分钟
                let seconds = parseInt(DateNow  % 60, 10);//计算剩余的秒数

                let daysStr = ''
                let hoursStr = ''
                let minutesStr = ''
                let secondsStr = ''


                days.toString().split('').map(v=>{
                    daysStr = daysStr + `<div>${v}</div>`
                })
                if (this.refs.limitDay) {
                    this.refs.limitDay.innerHTML = daysStr
                }

                hours.toString().split('').map((v)=>{
                    hours.toString().split('').length ==1 ? hoursStr = hoursStr + `<div>0</div><div>${v}</div>`
                        : hoursStr = hoursStr + `<div>${v}</div>`
                })
                if (this.refs.limitHour) {
                    this.refs.limitHour.innerHTML = hoursStr
                }

                minutes.toString().split('').map((v)=>{
                    minutes.toString().split('').length==1 ? minutesStr = minutesStr + `<div>0</div><div>${v}</div>`
                        : minutesStr = minutesStr + `<div>${v}</div>`
                })
                if (this.refs.limitMinute) {
                    this.refs.limitMinute.innerHTML = minutesStr
                }

                seconds.toString().split('').map((v)=>{
                    seconds.toString().split('').length==1 ? secondsStr = secondsStr + `<div>0</div><div>${v}</div>`
                        : secondsStr = secondsStr + `<div>${v}</div>`
                })
                if (this.refs.limitMs) {
                    this.refs.limitMs.innerHTML = secondsStr
                }
                this.beginCountdown(endTime)
            },1000)

        }
    }

    render(){
        return(
            <div className="coupon_countdown" >
                <div className="limit-bar-time fl">
                    <i>剩</i>
                    <span className="limit-bar-time__num" ref="limitDay"></span>
                    <i>天</i>
                    <span className="limit-bar-time__point"></span>

                    <span className="limit-bar-time__num" ref="limitHour"></span>
                    <i>时</i>
                    <span className="limit-bar-time__point"></span>

                    <span className="limit-bar-time__num" ref="limitMinute"></span>
                    <i>分</i>
                    <span className="limit-bar-time__point"></span>

                    <span className="limit-bar-time__num" ref="limitMs"></span>
                    <i>秒</i>
                </div>
            </div>

        )
    }
}

export default  CountDown


// WEBPACK FOOTER //
// ./src/components/activity/couponSPA/CountDown.js